// pages/index.js
import React, { useEffect } from "react"
import { useRouter } from "next/router"
import { useDispatch, useSelector } from "react-redux"

const Home = () => {
  const router = useRouter()
  const { user, accessToken } = useSelector((state) => state.auth)

  const isClient = !!(user.active === undefined || user.active === null ? 1 : user.active)

  useEffect(() => {
    if (accessToken) {
      if (isClient) {
        router.push("/bookings/active-upcoming-bookings")
      } else {
        router.push("/find-charger")
      }
    } else {
      router.push("/welcome")
    }
  }, [isClient, user, router, accessToken])

  return null
}

export default Home
